import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "../src/style.scss";
import { BrowserRouter, UNSAFE_createBrowserHistory } from 'react-router-dom';
import { AuthProvider } from 'react-oidc-context';
import { cognitoAuthConfig } from './components/cognito/Authentication';
import store from './stores/store';
import { Provider } from 'react-redux'
import "./i18n";

const history = UNSAFE_createBrowserHistory();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];

if (path) {
  history.replace(path);
}

root.render(
  <Provider store={store}>
    <AuthProvider {...cognitoAuthConfig}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
